import AffirmationProgramService from 'src/modules/affirmationProgram/affirmationProgramService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'AFFIRMATIONPROGRAM_FORM';

const affirmationProgramFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: affirmationProgramFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await AffirmationProgramService.find(id);
      }

      dispatch({
        type: affirmationProgramFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: affirmationProgramFormActions.INIT_ERROR,
      });

      getHistory().push('/affirmation-program');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: affirmationProgramFormActions.CREATE_STARTED,
      });

      await AffirmationProgramService.create(values);

      dispatch({
        type: affirmationProgramFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.affirmationProgram.create.success'),
      );

      getHistory().push('/affirmation-program');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: affirmationProgramFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: affirmationProgramFormActions.UPDATE_STARTED,
      });

      await AffirmationProgramService.update(id, values);

      dispatch({
        type: affirmationProgramFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.affirmationProgram.update.success'),
      );

      getHistory().push('/affirmation-program');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: affirmationProgramFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default affirmationProgramFormActions;
